/**
 * Service Worker 註冊工具
 * 負責在生產環境中註冊和管理 Service Worker
 */

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

/**
 * 註冊 Service Worker
 * @param {Object} config - 配置選項
 */
export function register(config) {
  // 只在生產環境或本地測試時啟用
  if (process.env.NODE_ENV === 'production' || isLocalhost) {
    // 檢查瀏覽器支援
    if ('serviceWorker' in navigator) {
      // 等待頁面完全載入
      window.addEventListener('load', () => {
        const swUrl = `${window.location.origin}/sw.js`;

        if (isLocalhost) {
          // 本地環境：檢查 SW 是否存在
          checkValidServiceWorker(swUrl, config);
          
          navigator.serviceWorker.ready.then(() => {
            console.log(
              '🧪 [開發模式] Service Worker 已就緒。' +
              '\n離線功能已啟用，但僅用於測試。'
            );
          });
        } else {
          // 生產環境：直接註冊
          registerValidSW(swUrl, config);
        }
      });
    }
  }
}

/**
 * 註冊有效的 Service Worker
 */
function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log('✅ Service Worker 註冊成功');

      // 監聽更新
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }

        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // 新版本可用
              console.log('🔄 新內容可用，將在所有分頁關閉後更新。');

              // 執行回調
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // 首次安裝完成
              console.log('✨ 內容已快取，可離線使用。');

              // 執行回調
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('❌ Service Worker 註冊失敗:', error);
    });
}

/**
 * 檢查 Service Worker 是否有效
 */
function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // Service Worker 不存在
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service Worker 存在，繼續註冊
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('🔌 無網路連線。應用程式正在離線模式運行。');
    });
}

/**
 * 取消註冊 Service Worker（用於開發測試）
 */
export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
        console.log('🗑️ Service Worker 已取消註冊');
      })
      .catch((error) => {
        console.error('❌ 取消註冊失敗:', error.message);
      });
  }
}

/**
 * 手動更新 Service Worker
 */
export function update() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.update();
        console.log('🔄 正在檢查更新...');
      })
      .catch((error) => {
        console.error('❌ 更新檢查失敗:', error.message);
      });
  }
}